/* Studio L — live search suggestions under the header search bar. */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 180;
  var PRODUCT_LIMIT = 4;
  var PAGE_LIMIT = 2;
  var SKIP_PAGE = /(avdelinger|kontakt|contact|faq|wishlist|om-oss|about|vilkar|vilkår|personvern|privacy|studio-l-sandefjord|studio-l-larvik)/i;

  function money(cents) {
    if (window.theme && typeof theme.formatMoney === 'function') {
      return theme.formatMoney(cents, theme.moneyWithoutCurrencyFormat || theme.moneyFormat);
    }
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return Math.round(n / 100).toLocaleString('nb-NO') + ' kr';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function suggestUrl(term) {
    var base = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
    var url = base + (base.indexOf('.json') === -1 ? '.json' : '');
    var params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product,page');
    params.set('resources[limit]', '6');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][unavailable_products]', 'hide');
    return url + '?' + params.toString();
  }

  function imageUrl(item) {
    var img = item.image || item.featured_image;
    if (!img) return '';
    var url = typeof img === 'string' ? img : img.url || img.src || '';
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') !== -1) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=128';
    }
    return url;
  }

  function pageMeta(page) {
    var url = page.url || '';
    if (SKIP_PAGE.test(url)) return 'Side';
    return 'Behandling';
  }

  function productMeta(product) {
    var parts = [];
    if (product.vendor) parts.push(product.vendor);
    if (product.type) parts.push(product.type);
    return parts.join(' · ') || 'Produkt';
  }

  function init(root) {
    var form = root.querySelector('[data-sl-search-form]');
    var input = root.querySelector('[data-sl-search-input]');
    var panel = root.querySelector('[data-sl-search-panel]');
    var list = root.querySelector('[data-sl-search-list]');
    var empty = root.querySelector('[data-sl-search-empty]');
    var emptyTerm = root.querySelector('[data-sl-search-empty-term]');
    var more = root.querySelector('[data-sl-search-more]');
    if (!form || !input || !panel || !list) return;

    var timer = null;
    var controller = null;
    var cache = {};
    var items = [];
    var active = -1;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function open() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(index) {
      active = index;
      var nodes = list.querySelectorAll('[data-sl-search-option]');
      nodes.forEach(function (node, i) {
        var on = i === active;
        node.setAttribute('aria-selected', on ? 'true' : 'false');
        node.classList.toggle('is-active', on);
        if (on) input.setAttribute('aria-activedescendant', node.id);
      });
      if (active < 0) input.removeAttribute('aria-activedescendant');
    }

    function render(term, payload) {
      var products = ((payload.resources || {}).results || {}).products || [];
      var pages = ((payload.resources || {}).results || {}).pages || [];
      items = [];

      products.slice(0, PRODUCT_LIMIT).forEach(function (p) {
        items.push({
          name: p.title,
          meta: productMeta(p),
          price: money(p.price),
          url: p.url,
          image: imageUrl(p)
        });
      });
      pages.slice(0, PAGE_LIMIT).forEach(function (p) {
        items.push({
          name: p.title,
          meta: pageMeta(p),
          price: '',
          url: p.url,
          image: imageUrl(p)
        });
      });

      list.innerHTML = items
        .map(function (item, i) {
          return (
            '<a id="sl-search-opt-' +
            i +
            '" class="sl-search__option" role="option" data-sl-search-option href="' +
            escapeHtml(item.url) +
            '" aria-selected="false">' +
            '<span class="sl-search__option-media">' +
            (item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="" width="64" height="64" loading="lazy">'
              : '') +
            '</span>' +
            '<span class="sl-search__option-text">' +
            '<span class="sl-search__option-name">' +
            escapeHtml(item.name) +
            '</span>' +
            '<span class="sl-search__option-meta">' +
            escapeHtml(item.meta) +
            '</span>' +
            '</span>' +
            (item.price ? '<span class="sl-search__option-price">' + escapeHtml(item.price) + '</span>' : '') +
            '</a>'
          );
        })
        .join('');

      var hasHits = items.length > 0;
      empty.hidden = hasHits;
      list.hidden = !hasHits;
      if (emptyTerm) emptyTerm.textContent = term;
      if (more) {
        more.hidden = false;
        more.textContent = 'Se alle treff for «' + term + '»';
      }
      active = -1;
      open();
    }

    function fetchTerm(term) {
      if (cache[term]) {
        render(term, cache[term]);
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      fetch(suggestUrl(term), { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.json();
        })
        .then(function (data) {
          cache[term] = data;
          if (input.value.trim() === term) render(term, data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
        });
    }

    function onInput() {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < MIN_CHARS) {
        close();
        return;
      }
      timer = setTimeout(function () {
        fetchTerm(term);
      }, DEBOUNCE_MS);
    }

    input.addEventListener('input', onInput);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && items.length) open();
    });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(active < items.length - 1 ? active + 1 : 0);
        return;
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(active > 0 ? active - 1 : items.length - 1);
        return;
      }
      if (e.key === 'Enter' && active >= 0) {
        var selected = list.querySelector('[aria-selected="true"]');
        if (selected) {
          e.preventDefault();
          selected.click();
        }
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    if (more) {
      more.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  document.querySelectorAll('[data-sl-search]').forEach(init);
})();
